import React from 'react';

const SearchButton = ({ onClick }) => {
    return (
        <button 
            className="ec-search-btn"
            onClick={onClick}
            aria-label="Buscar"
        >
            <i className="pi pi-search"></i>
        </button>
    );
};

export default SearchButton;
